import { render, staticRenderFns } from "./transaction-banking-sale-monitoring.vue?vue&type=template&id=58436c79&"
import script from "./transaction-banking-sale-monitoring.vue?vue&type=script&lang=js&"
export * from "./transaction-banking-sale-monitoring.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports